<template>
    <g width="150px" height="160px">
        <g transform="scale(0.3)">
          <text
            style="transform:translate(260px, 200px)"
            class="name st1"
            @click="displayValueBox"
            >인덕터{{ number }}({{ attr.henry }}µH)</text>
        </g>

        <g class="st0" transform="scale(0.27)">
            <path class="st0" d="M474.23,266.2h-96.27c0,0-2.68-6.44-13.76-6.44h-29.62c0,0-7.28-0.14-7.28,7.7v52.89c0,0-1.19,9.51,7.28,8.26
 l29.62,0c0,0,9.49,0.42,13.76-6.44h96.27c0,0,3.57,6.44,13.99,6.44h29.38c0,0,7.28,0.14,7.28-6.44V266.2c0,0,0.28-6.43-7.28-6.44
 h-29.38C488.22,259.76,478.36,259.9,474.23,266.2z" />
            <linearGradient id="SVGID_8_1" gradientUnits="userSpaceOnUse" x1="450.0777" y1="322.3078" x2="450.0777"
                y2="266.3387">
                <stop offset="0" style="stop-color:#FFFFFF" />
                <stop offset="1.011054e-08" style="stop-color:#E7E7E7" />
                <stop offset="2.623438e-08" style="stop-color:#C8C8C8" />
                <stop offset="4.451084e-08" style="stop-color:#ADACAC" />
                <stop offset="6.515840e-08" style="stop-color:#979696" />
                <stop offset="8.927537e-08" style="stop-color:#868585" />
                <stop offset="1.190832e-07" style="stop-color:#7B7A7A" />
                <stop offset="1.609190e-07" style="stop-color:#747373" />
                <stop offset="2.770450e-07" style="stop-color:#727171" />
                <stop offset="0.0992" style="stop-color:#757575" />
                <stop offset="0.1998" style="stop-color:#808080" />
                <stop offset="0.301" style="stop-color:#939393" />
                <stop offset="0.4025" style="stop-color:#ABACAC" />
                <stop offset="0.5036" style="stop-color:#C8C9CA" />
                <stop offset="0.5056" style="stop-color:#C9CACA" />
                <stop offset="0.5352" style="stop-color:#C3C4C4" />
                <stop offset="0.7489" style="stop-color:#999999" />
                <stop offset="0.9104" style="stop-color:#7C7C7C" />
                <stop offset="1" style="stop-color:#727171" />
            </linearGradient>
            <rect x="442.95" y="266.34" class="st1" width="14.26" height="55.97" />
            <linearGradient id="SVGID_8_2" gradientUnits="userSpaceOnUse" x1="405.9199" y1="322.2237" x2="405.9199"
                y2="266.2546">
                <stop offset="0" style="stop-color:#FFFFFF" />
                <stop offset="1.011054e-08" style="stop-color:#E7E7E7" />
                <stop offset="2.623438e-08" style="stop-color:#C8C8C8" />
                <stop offset="4.451084e-08" style="stop-color:#ADACAC" />
                <stop offset="6.515840e-08" style="stop-color:#979696" />
                <stop offset="8.927537e-08" style="stop-color:#868585" />
                <stop offset="1.190832e-07" style="stop-color:#7B7A7A" />
                <stop offset="1.609190e-07" style="stop-color:#747373" />
                <stop offset="2.770450e-07" style="stop-color:#727171" />
                <stop offset="0.0992" style="stop-color:#757575" />
                <stop offset="0.1998" style="stop-color:#808080" />
                <stop offset="0.301" style="stop-color:#939393" />
                <stop offset="0.4025" style="stop-color:#ABACAC" />
                <stop offset="0.5036" style="stop-color:#C8C9CA" />
                <stop offset="0.5056" style="stop-color:#C9CACA" />
                <stop offset="0.5352" style="stop-color:#C3C4C4" />
                <stop offset="0.7489" style="stop-color:#999999" />
                <stop offset="0.9104" style="stop-color:#7C7C7C" />
                <stop offset="1" style="stop-color:#727171" />
            </linearGradient>
            <rect x="398.79" y="266.25" class="st2" width="14.26" height="55.97" />
            <rect x="501.36" y="259.9" class="st3" width="9.58" height="68.84" />
            <rect x="501.36" y="280.33" class="st4" width="9.58" height="15.39" />
            <rect x="501.36" y="259.9" class="st5" width="9.58" height="20.43" />
            <linearGradient id="SVGID_8_3" gradientUnits="userSpaceOnUse" x1="265.1862" y1="285.8587" x2="265.1862"
                y2="303.1384" gradientTransform="matrix(-1 0 0 1 823.4794 0)">
                <stop offset="0" style="stop-color:#FFFFFF" />
                <stop offset="1.868180e-08" style="stop-color:#EDEDED" />
                <stop offset="5.778535e-08" style="stop-color:#CECECE" />
                <stop offset="1.020835e-07" style="stop-color:#B2B2B2" />
                <stop offset="1.521744e-07" style="stop-color:#9C9C9C" />
                <stop offset="2.106337e-07" style="stop-color:#8B8B8B" />
                <stop offset="2.829547e-07" style="stop-color:#808080" />
                <stop offset="3.843944e-07" style="stop-color:#797979" />
                <stop offset="6.659737e-07" style="stop-color:#777777" />
                <stop offset="0.1529" style="stop-color:#979392" />
                <stop offset="0.332" style="stop-color:#A3A2A2" />
                <stop offset="0.4162" style="stop-color:#A0A0A1" />
                <stop offset="0.571" style="stop-color:#9D9D9E" />
                <stop offset="0.6867" style="stop-color:#949494" />
                <stop offset="0.7898" style="stop-color:#848484" />
                <stop offset="0.8854" style="stop-color:#6D6D6E" />
                <stop offset="0.9751" style="stop-color:#505051" />
                <stop offset="1" style="stop-color:#474747" />
            </linearGradient>
            <path class="st6"
                d="M525.14,285.86h57.7c0,0,7.98-0.07,8.61,8.61c0,0-0.34,8.61-8.61,8.61l-57.7,0.07L525.14,285.86z" />
            <rect x="501.36" y="259.85" class="st7" width="9.58" height="68.79" />
            <rect x="339.09" y="260.1" class="st8" width="9.58" height="68.79" />
            <rect x="359.31" y="259.85" width="9.58" height="68.79" />
            <linearGradient id="SVGID_8_4" gradientUnits="userSpaceOnUse" x1="193.7886" y1="285.8587" x2="193.7886"
                y2="303.1384" gradientTransform="matrix(1 0 0 1 100.6027 0)">
                <stop offset="0" style="stop-color:#FFFFFF" />
                <stop offset="1.868180e-08" style="stop-color:#EDEDED" />
                <stop offset="5.778535e-08" style="stop-color:#CECECE" />
                <stop offset="1.020835e-07" style="stop-color:#B2B2B2" />
                <stop offset="1.521744e-07" style="stop-color:#9C9C9C" />
                <stop offset="2.106337e-07" style="stop-color:#8B8B8B" />
                <stop offset="2.829547e-07" style="stop-color:#808080" />
                <stop offset="3.843944e-07" style="stop-color:#797979" />
                <stop offset="6.659737e-07" style="stop-color:#777777" />
                <stop offset="0.1529" style="stop-color:#979392" />
                <stop offset="0.332" style="stop-color:#A3A2A2" />
                <stop offset="0.4162" style="stop-color:#A0A0A1" />
                <stop offset="0.571" style="stop-color:#9D9D9E" />
                <stop offset="0.6867" style="stop-color:#949494" />
                <stop offset="0.7898" style="stop-color:#848484" />
                <stop offset="0.8854" style="stop-color:#6D6D6E" />
                <stop offset="0.9751" style="stop-color:#505051" />
                <stop offset="1" style="stop-color:#474747" />
            </linearGradient>
            <path class="st9"
                d="M327.54,285.86h-57.7c0,0-7.98-0.07-8.61,8.61c0,0,0.34,8.61,8.61,8.61l57.7,0.07L327.54,285.86z" />
            <circle :id="pincode + 'PS'" class="pin-cover terminal snap res_plus" @click="onClick(`${pincode}PS`)" cx="260" cy="295" r="13" />
            <circle :id="pincode + 'MS'" class="pin-cover terminal snap res_minus" @click="onClick(`${pincode}MS`)" cx="590" cy="295" r="13" />
        </g>
    </g>
</template>

<script>
import store from '../../../../store/index.js'
import { pins } from '../../../../mixins/pin-util.js'

export default {
  props: ['data'],
  mixins: [pins],
  name: 'Inductor',
  data () {
    return {
      code: '',
      attr: {
        henry: 1,
      }
    }
  },
  mounted () {
    this.setPindata(this.data)
    this.code = this.namecode
  },
  computed: {
    values () {
      const data = store.state.sim.data
      if (data) return data.IT[Number(this.number)]
      return { volt: 0, amper: 0, resist: 0 }
    }
  },
  methods: {
    displayValueBox () {
      window.event.stopPropagation()
      store.state.valuebox.values.toggle = false
      store.commit('setValueBox', { type: 'values', toggle: true, id: this.data.id,
        unit: 'henry',
        code: 'IT' })
    },
    onClick (pin) {
      console.log('where is data?: ' + JSON.stringify(this.data))
      const name = this.data.id
      store.commit('wire/createLines', { name, pin })
      window.event.stopPropagation()
    }
  }

}
</script>

<style lang="scss" scoped>
.selected {
  .st0 {
      stroke-width: 4px;
      stroke: #ff6f61;
  }
}
.res_plus:hover,
.res_minus:hover {
  cursor: pointer;
  fill: #e60012;
}
.st0 {
  fill: #64a086;
}
.st1 {
  fill: url(#SVGID_8_1);
}
.st2 {
  fill: url(#SVGID_8_2);
}
.st3 {
  fill: #665f2f;
}
.st4 {
  fill: #a99c4e;
}
.st5 {
  fill: #cac345;
}
.st6 {
  fill: url(#SVGID_8_3);
}
.st7 {
  fill: #ffffff;
}
.st8 {
  fill: #4f4f42;
}
.st9 {
  fill: url(#SVGID_8_4);
}
.name{
  font-size: 48px;
}
.name:hover{
  cursor: pointer;
}
.pointer{
  cursor: pointer;
}
</style>
